import script from "./satellite-form.vue?vue&type=script&lang=ts&setup=true"
export * from "./satellite-form.vue?vue&type=script&lang=ts&setup=true"

import "./satellite-form.vue?vue&type=style&index=0&id=7ccf566a&lang=scss&scoped=true"

import exportComponent from "D:\\web\\operation-platform\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7ccf566a"]])

export default __exports__